import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <section className="page-section login-page"><p>{typeof window !== 'undefined' && window.localStorage.getItem('nextcompli.website.language') === 'es' ? 'Comprobando sesión...' : 'Checking session...'}</p></section>;
  }

  if (!isAuthenticated) {
    const ssoError = new URLSearchParams(location.search).get('sso_error');
    const loginPath = ssoError
      ? `/website/login?sso_error=${encodeURIComponent(ssoError)}`
      : '/website/login';
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
